module.exports = __webpack_public_path__ + "img/down-btn-ios-show.a3c3ee68.png";